import { Icon } from "@blueprintjs/core";
import type { EventContentArg } from "@fullcalendar/core/index.js";
import type { SchedulerEventExtendedProps } from "./calendar-utils";

export function SchedulerEventChip({ event, timeText }: EventContentArg) {
  const extendedProps = event.extendedProps as SchedulerEventExtendedProps;

  return (
    <div className="flex w-full min-w-0 items-center gap-1.5 text-xs">
      {timeText && (
        <span className="shrink-0 tabular-nums text-brand-muted">
          {timeText}
        </span>
      )}
      <span className="min-w-0 truncate font-medium text-brand-ink">
        {event.title}
      </span>
      {extendedProps?.recurring && (
        <Icon
          className="shrink-0 text-brand-muted"
          icon="repeat"
          size={11}
          title="Part of a recurring series"
        />
      )}
    </div>
  );
}
